<template>
  <div
    class="pt-24 md:h-screen dark:bg-black md:pt-16 lg:px-0 md:px-4"
    id="about-page"
  >
    <div data-aos="fade-up">
      <div class="flex-col hidden mx-auto text-left md:flex maxWidth">
        <div>
          <h1 class="text-6xl font-bold textBlue">About me</h1>
          <p class="text-xl font-normal dark:text-gray-300">
            Let me introduce myself
          </p>
        </div>
        <div class="flex w-full">
          <div class="w-1/2">
            <img
              src="https://i.postimg.cc/Gtn1MntF/Muneeb-min-1-new.png"
              alt="muneeb-davids"
              class=""
            />
          </div>
          <div
            class="relative p-5 bg-white rounded shadow-md right-16 top-36 dropShadow"
          >
            <h1 class="text-2xl font-bold text-left">A little about me</h1>
            <p class="mt-3 text-base font-normal text-left dark:text-black">
              Hi! I’m
              <a
                target="_blank"
                href="https://www.linkedin.com/in/mogamat-muneeb/"
                class="font-semibold no-underline cursor-pointer textBlue"
                >Mogamat Muneeb Davids </a
              >, a developer who has a passion for building clean web
              applications with instinctive functionality. I enjoy turning ideas
              into reality via coding. I'm a hardworking and time-conscious
              person. I'm always willing to assist others when in need as well
              as being comfortable around people. I'm confident and am open to
              new ideas...
            </p>
            <p class="text-base font-normal text-left dark:text-black">
              My passion for technology and coding began when I realized that
              technology was the future. I have always wondered how Web
              applications and Mobile apps were built, which is why I decided to
              dig deeper into Web Development and Coding.
            </p>
            <h1 class="pt-5 text-2xl font-bold text-left dark:text-black">
              Technologies and tools I've been working with recently
            </h1>
            <div class="flex gap-10 mt-5 md:gap-44 dark:text-black">
              <div class="flex flex-col items-start gap-2">
                <li>React</li>
                <li>Vue.Js</li>
                <li>Shopify</li>
                <li>Typescript</li>
                <li>Firebase</li>
              </div>
              <div class="flex flex-col items-start gap-2">
                <li>Node.JS</li>
                <li>MongoDB</li>
                <li>Figma</li>
                <li>Git</li>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col h-full md:hidden">
        <div class="text-center">
          <h1 class="text-6xl font-bold textBlue">About me</h1>
          <p class="text-3xl font-normal">Let me introduce myself</p>
        </div>
        <div class="flex justify-center mt-10 image px-auto">
          <img
            src="https://i.postimg.cc/Gtn1MntF/Muneeb-min-1-new.png"
            alt=""
          />
        </div>
        <div class="px-4 mt-3">
          <div class="p-5 bg-white rounded shadow-md">
            <h1 class="text-2xl font-bold">A little about me</h1>
            <p class="text-base font-normal">
              Hi! I’m
              <a
                target="_blank"
                href="https://www.linkedin.com/in/mogamat-muneeb/"
                class="font-semibold no-underline cursor-pointer textBlue"
                >Mogamat Muneeb Davids </a
              >, a developer who has a passion for building clean web
              applications with instinctive functionality. I enjoy turning ideas
              into reality via coding. I'm a hardworking and time-conscious
              person. I'm always willing to assist others when in need as well
              as being comfortable around people. I'm confident and am open to
              new ideas...
            </p>
            <p class="text-base font-normal text-left">
              My passion for technology and coding began when I realized that
              technology was the future. I have always wondered how Web
              applications and Mobile apps were built, which is why I decided to
              dig deeper into Web Development and Coding.
            </p>
            <h1 class="pt-3 text-2xl font-bold">
              Technologies and tools I've been working with recently
            </h1>
            <div class="flex gap-20 pt-3">
              <div class="flex flex-col items-start gap-2">
                <li>React</li>
                <li>Vue.Js</li>
                <li>Shopify</li>
                <li>Typescript</li>
                <li>Firebase</li>
              </div>
              <div class="flex flex-col items-start gap-2">
                <li>Node.JS</li>
                <li>MongoDB</li>
                <li>Figma</li>
                <li>Git</li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.image img {
  width: 400px;
  height: 400px;
  object-fit: cover;
}
</style>
<script>
import AOS from "aos";
import { onMounted } from "vue";
export default {
  setup() {
    onMounted(() => {
      AOS.init();
    });
  },
};
</script>
